import type { App } from 'vue';
import * as Sentry from '@sentry/vue';

const TRACE_PROPAGATION_TARGETS: (string | RegExp)[] = [
    'localhost',
    'local.kigaroo.de',
    'kigaroo.local',
    'clubity.local',
    'uneto.local',
    'app.kigaroo.de',
    'app.clubity.com',
    'app.uneto.de',
    /^https:\/\/stage\d{1,2}\.(kigaroo|clubity)\.com/,
];

const RELEASE = 'kigaroo-frontend';

function isEnabled(): boolean {
    return import.meta.env.VITE_SENTRY_ENABLED === '1' && Boolean(import.meta.env.VITE_SENTRY_DSN);
}

export function initSentry(): void {
    if (!isEnabled() || Sentry.getClient()) {
        return;
    }

    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        release: RELEASE,
        environment: 'general',

        integrations: (integrations) => [
            ...integrations.filter((integration) => integration.name !== 'Vue'),
            Sentry.browserTracingIntegration(),
        ],

        tracesSampleRate: 0.05,
        tracePropagationTargets: TRACE_PROPAGATION_TARGETS,
    });
}

export interface UseSentryOptions {
    attachProps?: boolean
}

export function useSentry(app?: App, options: UseSentryOptions = {}): void {
    initSentry();

    if (!app || !isEnabled() || !Sentry.getClient()) {
        return;
    }

    Sentry.attachErrorHandler(app, { attachProps: options.attachProps ?? true });
}
